import PropTypes from 'prop-types'

const Loader = (props) => {
  const { color, modifiers } = props

  const modifierClasses = modifiers ? ' ' + modifiers.join(' ') : ''

  return (
    <svg className={`Loader${modifierClasses}`} x="0px" y="0px" viewBox="0 0 100 100" fill={!color ? '#253780' : color}>
      <polygon
        className="Loader-segment Loader-segment--one"
        points="55.44,40.44 44.54,40.44 32.54,22.82 50,5.51 67.46,22.82 "
      />
      <polygon
        className="Loader-segment Loader-segment--two"
        points="59.98,44.14 59.98,55.04 77.6,67.05 94.91,49.59 77.6,32.12 "
      />
      <polygon
        className="Loader-segment Loader-segment--three"
        points="55.44,59.56 44.54,59.56 32.54,77.18 50,94.49 67.46,77.18 "
      />
      <polygon
        className="Loader-segment Loader-segment--four"
        points="40.02,44.14 40.02,55.04 22.4,67.05 5.09,49.59 22.4,32.12 "
      />
    </svg>
  )
}

export default Loader

Loader.propTypes = {
  color: PropTypes.string,
  modifiers: PropTypes.array
}
